import { get } from './api-service';

const routes = {
  base: 'locations',
};

export const getLocations = async filters => {
  return await get(`${routes.base}${filters}`);
}
